// The transactions behind one account's comparison, read on demand: this
// mounts only when a row (Overview) or the bank-feed line (Expenses) is
// expanded, and only then calls bank_unmatched. Markup: UnmatchedListsView.
import React from "react";
import { useQbo } from "../lib/useQbo.js";
import { UnmatchedListsView } from "./BankParts.jsx";

/** row: a bankOverview row (its counts tell a list cut short by the server). only: see UnmatchedListsView. */
export default function UnmatchedLists({ ctx, accountId, row, only }) {
  const q = useQbo(ctx, "bank_unmatched", { accountId });
  return (
    <UnmatchedListsView data={q.data} loading={q.loading} error={q.error} onRetry={q.refresh} only={only}
      expected={row ? { notInBooks: row.notInBooks, notAtBank: row.notAtBank } : undefined} />
  );
}
